"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../lib/helpers");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const Avatar_1 = __importDefault(require("./Avatar"));
const AvatarStack = (props) => {
    const { children, srcs } = props;
    return (react_1.default.createElement("div", Object.assign({}, helpers_1.usePrimitiveProps(props)),
        srcs.map((src, index) => {
            const styles = {
                zIndex: srcs.length - index,
                left: index * 25,
            };
            return (react_1.default.createElement("div", { className: "j-avatar-div", key: src },
                react_1.default.createElement(Avatar_1.default, { src: src, key: src, style: styles })));
        }),
        children));
};
exports.default = withJourney_1.default('j-avatar-stack', AvatarStack);
